import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

export default function BasicTable({ columns, rows }) {
  return (
    <TableContainer style={{ backgroundColor: "white" }} component={Paper}>
      <Table size="small" aria-label="simple table">
        <TableHead>
          <TableRow>
            {columns.map((clm) => (
              <TableCell
                className="table__column"
                style={{
                  color: "#393C71",
                  fontFamily: "'Montserrat', sans-serif",
                  fontWeight: "700",
                  borderBottom: "3px solid rgb(54, 61, 161)",
                }}
              >
                {clm}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => (
            <TableRow
              key={i}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              {row.map((cell) => (
                <TableCell
                  className="table__row"
                  style={{
                    color: "#393C71",
                    fontFamily: "'Montserrat', sans-serif",
                    fontWeight: "700",
                    borderBottom: "0.5px solid rgb(54, 61, 161)",
                  }}
                  component="th"
                  scope="row"
                >
                  {cell}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
